// Mirrors the question_type derivation in Card::Question::Hidden#hidden_question_attributes
// (api/app/models/card/concerns/question_generatable.rb). Keep in sync if new transformation types are added.
const MULTIPLE = ["Multiple Match (Closed)", "User attribute (Multiple)", "Conditions (Multiple)"];
const OPEN = ["Mailing contact attribute (Open)"];
const MATRIX = ["Single Match (Matrix)", "Multiple Match (Matrix)"];
const MATRIX_MULTIPLE = ["Multiple Match (Matrix)"];

export function hiddenCardQuestionType(card) {
  const t = card.specs?.transformation_type;
  if (MULTIPLE.includes(t)) return "multiple";
  if (OPEN.includes(t)) return "open";
  if (MATRIX.includes(t)) return "matrix";
  return "single";
}

// A matrix question, or a matrix recode (q_hidden with one generated question per item).
export function isMatrixLikeCard(card) {
  if (!card) return false;
  return card.type === "q_matrix" || (card.type === "q_hidden" && hiddenCardQuestionType(card) === "matrix");
}

// Several answers per item: stacked 100% cannot render it.
export function isMatrixMultipleLikeCard(card) {
  if (!card) return false;
  if (card.type === "q_matrix") return card.specs?.matrix_type === "multiple";
  return card.type === "q_hidden" && MATRIX_MULTIPLE.includes(card.specs?.transformation_type);
}

// One respondent can hit several answers/codes, so stacked 100% and pie make no sense.
// Recodes (codifications…) are q_hidden cards whose multiplicity is derived from their specs.
export function isMultipleLikeCard(card) {
  if (!card) return false;
  if (["q_multiple", "q_ranking"].includes(card.type)) return true;
  return card.type === "q_hidden" && hiddenCardQuestionType(card) === "multiple";
}

export const OPEN_RECODE_TRANSFORMATION = "Open (AI Generated)";

export function isOpenRecodeCard(card) {
  return card?.specs?.transformation_type === OPEN_RECODE_TRANSFORMATION;
}

export function isCodificationCard(card) {
  return card?.is_recode_question === true || isOpenRecodeCard(card);
}
